import React, { useState, useRef, useEffect } from "react";
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";

import TestimonialsImg1 from "../Images/TestimonialImg/Testimonial1.jpg";
import TestimonialsImg2 from "../Images/TestimonialImg/Testimonial2.jpg";
import TestimonialsImg3 from "../Images/TestimonialImg/Testimonial3 .jpg";
import TestimonialsImg4 from "../Images/TestimonialImg/Testimonial4.jpg";
import TestimonialsImg5 from "../Images/TestimonialImg/Testimonial5.jpg";
import TestimonialsImg6 from "../Images/TestimonialImg/Testimonial6.jpg";
import TestimonialsImg7 from "../Images/TestimonialImg/Testimonial7.jpg";
import TestimonialsImg9 from "../Images/TestimonialImg/shivani.jpeg";

const testimonialsData = [
  {
    name: "Vanshika -Social Media Executive",
    rating: 5,
    text: `Seobix is a really helpful website for my SEO work. It shows clear keyword data and backlink info, The tools are easy to use, even for beginners.Their support team is also very friendly and quick to help.  `,
    highlight: "I’m happy using seobix .👍🏻",
    avatar: TestimonialsImg1,
  },
  {
    name: "Himashu -Digital Marketing Specialist",
    rating: 5,
    text: `SeoBix exceeded my expectations. The SEO Inspector, on-page SEO, keyword analysis, and user-friendly dashboard make it incredibly effective. It simplified everything for me.   `,
    highlight:
      "I’ve seen real results—one of the best SEO tools I have ever used!",
    avatar: TestimonialsImg2,
  },
  {
    name: "Harsh -SEO Executive",
    rating: 5,
    text: `SeoBix specializes in helping small and medium businesses achieve tangible results through strategic online marketing.  `,
    highlight:
      " SeoBix combines creativity with data to deliver measurable growth.",
    avatar: TestimonialsImg3,
  },
  {
    name: "Amit -Content Strategist",
    rating: 5,
    text: `I have been using SeoBix for a while now, and it’s honestly one of the easiest SEO tools I’ve come across. From audits to keyword tracking, it does everything.   `,
    highlight: "Great tool for anyone trying to grow online!",
    avatar: TestimonialsImg4,
  },
  {
    name: "Parth -Google Ads Specialist",
    rating: 5,
    text: `Seobix is an easy-to-use SEO tool that helps check website issues, find keywords, and improve Google rankings quickly, you can check your sites Da, Pa, and spam score very easily.  `,
    highlight: "Great tool to improve your website's SEO!",
    avatar: TestimonialsImg5,
  },
  {
    name: "Tanishka -SEM Executive",
    rating: 5,
    text: `SEOBIX has been instrumental in boosting our online presence. Their SEO strategies significantly improved our website traffic and search engine rankings. SEOBIX is a great choice. `,
    highlight: " Highly satisfied with their performance. ",
    avatar: TestimonialsImg6,
  },
  {
    name: "Raghav -SEO Specialist",
    rating: 5,
    text: `I use seobix for my daily SEO work, and it’s really good. It helps me very much in finding right keywords and check backlinks and I like how fast and helpful the tool is i think   `,
    highlight:
      "It’s a great tool for anyone who wants to improve website ranking.",
    avatar: TestimonialsImg7,
  },
  {
    name: "Shivani -SEO Analyst",
    rating: 5,
    text: `I use seobix for my daily SEO work, and it’s really good. It helps me very much in finding right keywords and check backlinks and I like how fast and helpful the tool is i think   `,
    highlight:
      "Seobix is great for beginners. It shows what’s wrong with your website and gives tips to fix it fast and easily.",
    avatar: TestimonialsImg9,
  },
];

const TestimonialCard = React.forwardRef(({ testimonial }, ref) => (
  <div className="testimonial-card" ref={ref}>
    {/* Top-left quote */}
    <div className="quote-icon top-left">
      <RiDoubleQuotesL />
    </div>

    {/* User Info */}
    <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
      <img
        src={testimonial.avatar}
        alt={testimonial.name}
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          objectFit: "cover",
          marginRight: 12,
        }}
      />
      <span style={{ color: "#FFD700", fontSize: "1.5rem", marginRight: 8 }}>
        {"★".repeat(testimonial.rating)}
      </span>
      <span style={{ fontWeight: "bold", marginRight: 8 }}>
        ({testimonial.rating}/5)
      </span>
      <span style={{ fontStyle: "italic" }}>{testimonial.name}</span>
    </div>

    {/* Testimonial Text */}
    <div style={{ fontSize: "1.1rem", textAlign: "left", marginBottom: 8 }}>
      <span>{testimonial.text}</span>{" "}
      <span style={{ fontWeight: "bold", fontStyle: "italic" }}>
        {testimonial.highlight}
      </span>
    </div>

    {/* Bottom-right quote */}
    <div className="quote-icon bottom-right">
      <RiDoubleQuotesR />
    </div>
  </div>
));

const TestimonialPage = () => {
  const [visible, setVisible] = useState(3);
  const lastCardRef = useRef(null);
  // useEffect(() => {
  //   if (lastCardRef.current) {
  //     lastCardRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [visible]);

  return (
    <div style={{ overflowX: "hidden" }}>
      <div className="row mt-3">
        <div className="col-md-2"></div>
        <div className="col-md-8 text-center">
          <h3><b>SeoBix Clients' Testimonials</b></h3>
          {testimonialsData.slice(0, visible).map((t, idx) => (
            <TestimonialCard
              testimonial={t}
              key={idx}
              ref={idx === visible - 1 ? lastCardRef : null}
            />
          ))}
          {visible < testimonialsData.length ? (
            <button
              className="btn btn-primary mt-3"
              onClick={() => setVisible(visible + 2)}
            >
              View More
            </button>
          ) : (
            <div className="mt-3 text-muted">
             Reached
            </div>
          )}
        </div>
        <div className="col-md-2"></div>
      </div>
      <style>{`
        .testimonial-card {
  background: #fff;
  border: 2px solid #cfe2ff;
  border-radius: 16px;
  margin: 25px 0;
  padding: 20px 32px;
  position: relative;
}

.quote-icon {
  position: absolute;
  background-color: #799EFF;
  border-radius: 50%;
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
}


.quote-icon.top-left {
  top: -20px;
  left: -20px;
}


.quote-icon.bottom-right {
  bottom: -20px;
  right: -20px;
}

@media (max-width: 576px) {
  .quote-icon {
    height: 2.5rem;
    width: 2.5rem;
    font-size: 1rem;
  }

  .quote-icon.top-left {
    top: -15px;
    left: -15px;
  }

  .quote-icon.bottom-right {
    bottom: -15px;
    right: -15px;
  }
}


      `}</style>
    </div>
  );
};
export default TestimonialPage;
